import React, { useRef } from 'react';
import JoditEditor from 'jodit-react';
import {
  createDisabledDateForRanges,
  createDateRangeField
} from '../../utils/dateRangeFieldUtils';

export const useFields = ({
  generalConditions,
  purpose,
  generalConditionToEdit
}) => {
  const editorRef = useRef(null);
  const disabledDate = createDisabledDateForRanges(
    generalConditions,
    purpose,
    generalConditionToEdit
  );

  const fields = [
    createDateRangeField(['application_date'], disabledDate),
    createDateRangeField(['end_date'], disabledDate),
    {
      name: ['content'],
      rules: [{ required: true }],
      input: (
        <JoditEditor
          ref={editorRef}
          style={{ height: '300px', marginBottom: '20px' }}
        />
      )
    }
  ];

  return { fields };
};
